var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapSearchCtrl = function () {
    function MapSearchCtrl(GeoCodeService, $element, repairMapDelay) {
        _classCallCheck(this, MapSearchCtrl);

        if (!window.google || !window.google.maps) {
            throw new Error('google map api not found');
        }

        this.mapsApi = window.google.maps;
        this.geocode = GeoCodeService;
        // predefine search input element
        this.input = $element[0].children[0].children[0].children[0];
        this.delay = repairMapDelay;

        this.places = [];
        this.searchParam = '';

        this.showResults = false;
        this.inSearch = false;

        this.autocomplete = new this.mapsApi.places.AutocompleteService();
    }

    _createClass(MapSearchCtrl, [{
        key: 'onSearchChange',
        value: function onSearchChange() {
            var _this = this;

            if (this.validForSearch()) {
                this.autocomplete.getPlacePredictions({
                    bounds: this.mapInstance.getBounds(),
                    input: this.searchParam
                }, function (predictions, status) {
                    _this.setPlaces(predictions, status);
                });
            } else {
                this.places = [];
            }
        }
    }, {
        key: 'validForSearch',
        value: function validForSearch() {
            return this.searchParam && this.searchParam.trim().length > 0;
        }
    }, {
        key: 'setPlaces',
        value: function setPlaces(predictions, status) {
            var _this2 = this;

            this.places = [];

            if (status !== this.mapsApi.places.PlacesServiceStatus.OK) {
                console.warn('Places search is unavailable. ' + status);
                return;
            }

            predictions.forEach(function (prediction) {
                _this2.places.push(prediction);
            });

            this.input.blur();
            this.input.focus();
        }
    }, {
        key: 'selectPlace',
        value: function selectPlace(prediction) {
            var _this3 = this;

            this.showResults = false;
            this.inSearch = false;
            this.places = [];
            this.searchParam = prediction.description;

            this.geocode.geocodePlace(prediction.place_id).then(function (cords) {
                _this3.changeMapCenter({ cords: cords });
            });
        }
    }, {
        key: 'showList',
        value: function showList() {
            this.input.selectionEnd = this.input.value.length;
            this.input.selectionStart = this.input.selectionEnd;
            this.showResults = true;
        }
    }, {
        key: 'hideList',
        value: function hideList() {
            if (!this.inSearch) {
                this.showResults = false;
            }
        }
    }, {
        key: 'selectSearchAddress',
        value: function selectSearchAddress(search) {
            var _this4 = this;

            if (search) {
                this.showResults = false;
                this.inSearch = false;

                setTimeout(function () {
                    _this4.selectStaticAddress({ search: search });
                }, this.delay);
            }
        }
    }]);

    return MapSearchCtrl;
}();

MapSearchCtrl.$inject = ['GeoCodeService', '$element', 'repairMapDelay'];
export default MapSearchCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/components/MapSearch/MapSearchCtrl.js
// module id = 1487
// module chunks = 0